const routes = {
  login: {
    root: "/login",
  },
  homePage: {
    homePage: "/homePage",
  },
  customerOrders: {
    customerOrders: "/customerOrders",
  },
  orderDetails: {
    orderDetails: "/orderDetails",
  },
  logCashFlow: {
    logCashFlow: "/logCashFlow",
  },
  exportDaySheet: {
    exportDaySheet: "/exportDaySheet",
  },
};

export default routes;
